import React from 'react'
import WrapperByRole, { WrapperByRoleProps } from '../Wrapper/WrapperByRole'

const VendorWrapper: React.FC<WrapperByRoleProps> = (props) =>
  <WrapperByRole role='vendor' {...props} />

export default VendorWrapper